import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Button, Form, Space } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import { useOrderFiltersStore } from 'shared/stores';
import { OrdersFiltersDrawer } from './components/orders-filters-drawer';
import { OrdersSearch } from './components/orders-search';

export const OrdersFilter: React.FC = () => {
  const { t } = useTranslation();
  const { filters, search } = useOrderFiltersStore();
  const [isOpen, setIsOpen] = useState(false);
  const [form] = Form.useForm();

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <Space size='small'>
        <OrdersSearch />
        <Badge dot={!!filters}>
          <Button type='primary' icon={<FilterOutlined />} disabled={!!search} ghost onClick={handleOpen}>
            {t('common:filters')}
          </Button>
        </Badge>
      </Space>
      <OrdersFiltersDrawer form={form} isOpen={isOpen} onClose={handleClose} />
    </>
  );
};
